<template>
  <div class="header">
    <div class="content">
      <div class="left">
        <div class="flex justify-center items-center">
          <!--          <img-->
          <!--            src="https://res.hangxintong.cn/nxjpWx/icon/hqt-logo.png"-->
          <!--            alt=""-->
          <!--            class="h-68 w-68 borderRadius-50"-->
          <!--          />-->
          <!--          <img src="@/assets/img/hqt-logobx.png" class="h-60 w-136" alt="" />-->
          <img
            src="@/assets/img/nxjp-logobx.png"
            alt=""
            class="h-60 w-136"
          />
        </div>
        <div class="mr-80">
          <!--行企通-->
          <!--<div class="fontSize-11">HANGQITONG</div>-->
        </div>
        <div class="menu flex justify-center items-center">
          <template v-for="menu in menus" :key="menu.id">
            <div
              class="menu-item"
              :class="{ active: route.path.includes(menu.path) }"
              @click="handleSelect(menu)"
            >
              {{ menu.name }}
            </div>
          </template>
        </div>
      </div>
      <div class="right">
        <div
          class="flex justify-center items-center color-white fontSize-14 mr-42 cursor-pointer"
          @click="toCart"
        >
          <SvgIcon name="cart-white" size="22" class="mr-6" />
          <span class="fanhuisa">
            购物车
            <span v-show="userStore.getUserInfo">({{ cartCount || 0 }})</span>
          </span>
        </div>
        <div
          v-if="userStore.getUserInfo"
          class="flex justify-center items-center color-white fontSize-14 mr-42 cursor-pointer"
          style="margin-top: 5px"
          @click="toNotice"
        >
          <el-badge :is-dot="BellShow" class="item">
            <el-icon color="#fff" size="24">
              <Bell />
            </el-icon>
          </el-badge>
        </div>
        <div
          v-if="!userStore.getUserInfo"
          class="button flex justify-center items-center"
        >
          <div class="button-item mr-8 cursor-pointer" @click="handleLogin">
            登录
          </div>
          /
          <div
            class="button-item ml-8 cursor-pointer"
            @click="handleLogin('register')"
          >
            注册
          </div>
        </div>
        <div
          v-else
          class="flex items-center"
          style="background: #fff; border-radius: 20px"
        >
          <div
            class="p-2 bg-#fff borderRadius-50 flex justify-center items-center mr-8"
          >
            <img
              :src="
                (userStore.getUserInfo && userStore.getUserInfo.face) ||
                'https://res.hangxintong.cn/uniXkb/share/hqt-logo.jpg'
              "
              class="w-32 h-32 borderRadius-50"
            />
          </div>
          <el-dropdown trigger="click">
            <span
              class="el-dropdown-link color-#586168 fs-15 cursor-pointer flex items-center gap-x-8"
              style="padding-right: 8px"
            >
              <div
                style="
                  width: 60px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{
                  userStore.getUserInfo.name || userStore.getUserInfo.mobile
                }}</div
              >
              <el-icon color="#586168" size="14"><ArrowDownBold /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  icon="User"
                  @click="router.push('/user/userInfo')"
                >
                  个人中心
                </el-dropdown-item>
                <el-dropdown-item icon="SwitchButton" @click="logOut">
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    <CommonAffix />
    <Transition name="fade">
      <LightLogin
        :type="loginType"
        v-if="userStore.getShowLoginStatus"
      ></LightLogin>
    </Transition>
  </div>
</template>

<script setup>
import router from '@/router'
import { useUserStore } from '@/store/modules/user'
import { shoppingCarList } from '@/api/ShoppingCart'
import mitt from 'mitt'
import { isHaveView } from '@/api/user'

const route = useRoute()
const userStore = useUserStore()
const loginType = ref('weChat')
const cartCount = ref(localStorage.getItem('cartCount') || '0')
// 使用全局事件总线
const emitter = window.emitter
const BellShow = ref(false)

const handleSelect = menu => {
  if (menu.id == 5 && !userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  router.push({ path: menu.path })
}
const menus = ref([
  {
    id: '1',
    name: '首页',
    path: '/dashboard',
  },
  {
    id: '2',
    name: '课程中心',
    path: '/course',
  },
  {
    id: '3',
    name: '考试报名',
    path: '/exam',
  },
  {
    id: '4',
    name: '学考中心',
    path: '/studyCenter',
  },
  {
    id: '5',
    name: '个人中心',
    path: '/user',
  },
])

// 监听购物车数量变化事件
onMounted(() => {
  if (emitter) {
    emitter.on('cartCountUpdate', count => {
      console.log('commonHeader received cartCountUpdate222222222:', count)
      cartCount.value = count
    })
  }
  if (userStore.getToken) {
    isHaveViewFun()
  }
})

function isHaveViewFun() {
  isHaveView().then(res => {
    BellShow.value = res.data
  })
}

// 组件卸载时移除事件监听
onUnmounted(() => {
  if (emitter) {
    emitter.off('cartCountUpdate')
  }
})

// 回到旧培训页
function toOldPage() {
  if (process.env.NODE_ENV == 'development') {
    window.open('http://688pxdev.hangxintong.cn')
  } else {
    window.open('https://hqtpx-old.hangxintong.cn/')
  }
}

// 登录、注册
function handleLogin(key) {
  userStore.setShowLogin(false, '')
  if (key == 'register') {
    userStore.setShowLogin(true, 'register')
  } else {
    userStore.setShowLogin(true, 'weChat')
  }
}

// 退出登录
function logOut() {
  userStore.logout()
  router.push('/')
}

watch(
  () => userStore.getShowLoginStatus,
  () => {
    if (!userStore.getShowLoginStatus) {
      // 关闭轻登录 设置为账号登录
      loginType.value = 'pwd'
    }
  }
)

function toNotice() {
  router.push('/user/Notification')
}

// 购物车
function toCart() {
  if (!userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  router.push('/cart')
}
</script>

<style scoped lang="scss">
.fanhuisa {
  font-family: MicrosoftYaHei;
  color: #ffffff;
  font-size: 15px;
}

.header {
  position: sticky;
  top: 0;
  z-index: 2001;
  height: 70px;
  background: linear-gradient(
    270deg,
    #7ce9ff 0%,
    #166af7 20%,
    #166af7 80%,
    #77e4ff 100%
  );
  //height: 370px;
  //box-shadow: 0 3px 12px 0 rgba(0, 36, 153, 0.06);

  .content {
    width: 1345px;
    padding-right: 20px;
    margin: 6px auto;
    //height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .menu {
        .menu-item {
          height: 32px;
          border-radius: 4px;
          font-family: PingFangSC-regular;
          color: #ffffff;
          font-weight: 400;
          font-size: 18px;
          margin-right: 24px;
          cursor: pointer;
          line-height: 32px;
          width: 100px;
          text-align: center;
        }

        .active {
          background-color: #68a0ff;
          color: #fff;
          font-weight: 600;
        }
      }
    }

    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .button {
        background-color: #fff;
        border-radius: 16px;
        padding: 6px 11px;
        color: rgba(30, 118, 244, 1);

        .button-item {
          &:hover {
            opacity: 0.75;
          }
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: top 0.3s;
}

.fade-enter,
.fade-leave-active {
  top: -100vh;
}
</style>
